import { createSelector } from "@reduxjs/toolkit";
import { SET_SAVED_ALBUMS, SET_SAVED_ALBUMS_ORDER, SET_SAVED_ALBUMS_LAYOUT, RESET_SAVED_ALBUMS, SET_SAVED_ALBUMS_WARNINGS, SET_SAVED_ALBUMS_CURRENT_PAGE, SET_SAVED_ALBUMS_TYPE_FILTER, SET_SAVED_ALBUMS_TEXT_FILTER, SET_FILTERED_SAVED_ALBUMS, RESET_SAVED_ALBUMS_TEXT_FILTER } from "../actions/albumListActions";
import { ALBUM_LAYOUTS, ALBUM_SORTINGS } from "../utils/constants/enumConstants";
import { areAlbumFiltersEmpty } from "../utils/spotifyUtils";

export const getSavedAlbums = createSelector(
    state => state.albumListState.savedAlbums,
    savedAlbums => savedAlbums.albums
);

export const getFilteredSavedAlbums = createSelector(
    state => state.albumListState.savedAlbums,
    savedAlbums => savedAlbums.filteredAlbums
);

const filterAlbumsByPage = (albums, currentPage, pageSize) => {
    if(pageSize === 0) return albums;
        
    const result = albums.slice(currentPage * pageSize, (currentPage + 1) * pageSize);
    return result;
}

export const getPagedSavedAlbums = createSelector(
    [
        (state) => state.albumListState.savedAlbums.albums,
        (state) => state.albumListState.displayOptions.currentPage,
        (state) => state.userSettingsState.albumListPageSize.currentSize
    ],
    filterAlbumsByPage
);

export const getPagedFilteredSavedAlbums = createSelector(
    [
        (state) => state.albumListState.savedAlbums.filteredAlbums,
        (state) => state.albumListState.displayOptions.currentPage,
        (state) => state.userSettingsState.albumListPageSize.currentSize
    ],
    filterAlbumsByPage
);

export const getSavedAlbum = createSelector(
    [
        (state) => state.albumListState.savedAlbums.albums,
        (_, index) => index
    ],
    (albums, index) => {
        return albums[index];
    }
);

export const getSavedAlbumsLength = createSelector(
    state => state.albumListState.savedAlbums,
    savedAlbums => savedAlbums.albums && savedAlbums.albums.length
);

export const getFilteredSavedAlbumsLength = createSelector(
    state => state.albumListState.savedAlbums,
    savedAlbums => savedAlbums.filteredAlbums && savedAlbums.filteredAlbums.length
)

export const getSavedAlbumsOrder = createSelector(
    state => state.albumListState.displayOptions,
    displayOptions => displayOptions.order
);

export const getSavedAlbumsLayout = createSelector(
    state => state.albumListState.displayOptions,
    displayOptions => displayOptions.layout
);

export const isSavedAlbumsReset = createSelector(
    state => state.albumListState.savedAlbums,
    savedAlbums => savedAlbums.reset
);

export const getSavedAlbumsWarnings = createSelector(
    state => state.savedAlbums,
    savedAlbums => savedAlbums.warnings
);

export const areAddedAlbums = createSelector(
    state => state.albumListState.warnings,
    warnings => warnings.addedAlbums
);

export const areRemovedAlbums = createSelector(
    state => state.albumListState.warnings,
    warnings => warnings.removedAlbums
);

export const getCurrentPage = createSelector(
    state => state.albumListState.displayOptions,
    displayOptions => displayOptions.currentPage
);

export const getSavedAlbumsFilters = createSelector(
    state => state.albumListState.displayOptions.filters,
    filters => { return {...filters} }
);

export const areSavedAlbumsFiltersEmpty = createSelector(
    state => state.albumListState.displayOptions.filters,
    filters => areAlbumFiltersEmpty(filters)
);

export const getSavedAlbumsTypeFilter = createSelector(
    state => state.albumListState.displayOptions.filters,
    filters => filters.types
);

export const getSavedAlbumsTextFilter = createSelector(
    state => state.albumListState.displayOptions.filters,
    filters => filters.textPattern
);

export const isSavedAlbumsTextFilterReset = createSelector(
    state => state.albumListState.displayOptions.filters,
    filters => filters.resetTextPattern
);

const INITIAL_STATE = {
    savedAlbums: {
        albums: [],
        filteredAlbums: [],
        reset : true
    },
    displayOptions: {
        order: ALBUM_SORTINGS.playedRecently,
        layout: ALBUM_LAYOUTS.list,
        filters: {
            types: [],
            textPattern: "",
            resetTextPattern: false
        },
        currentPage: 0,
        pageSize: 0
    },
    warnings:
    {
        addedAlbums: false,
        removedAlbums: false   
    }
}

export const albumListState = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_SAVED_ALBUMS:
            return {...state, savedAlbums: {...state.savedAlbums, albums: action.payload }};
        case SET_FILTERED_SAVED_ALBUMS:
            return {...state, savedAlbums: {...state.savedAlbums, filteredAlbums: action.payload }};
        case SET_SAVED_ALBUMS_ORDER:
            return {...state, displayOptions: {...state.displayOptions, order: action.payload }};
        case SET_SAVED_ALBUMS_LAYOUT:
            return {...state, displayOptions: {...state.displayOptions, layout: action.payload }};
        case RESET_SAVED_ALBUMS: 
            return {...state, savedAlbums: {...state.savedAlbums, reset: action.payload }};
        case SET_SAVED_ALBUMS_WARNINGS:
            return {...state, warnings: action.payload };
        case SET_SAVED_ALBUMS_CURRENT_PAGE:
            return {...state, displayOptions: {...state.displayOptions, currentPage: action.payload }};
        case SET_SAVED_ALBUMS_TYPE_FILTER:
            return {...state, displayOptions: {
                    ...state.displayOptions, filters: {
                    ...state.displayOptions.filters, types: action.payload }}}
        case SET_SAVED_ALBUMS_TEXT_FILTER:
            return {...state, displayOptions: {
                    ...state.displayOptions, filters: {
                    ...state.displayOptions.filters, textPattern: action.payload }}}
        case RESET_SAVED_ALBUMS_TEXT_FILTER:
            return {...state, displayOptions: {
                    ...state.displayOptions, filters: {
                    ...state.displayOptions.filters, resetTextPattern: action.payload }}}
        default:
            return state;
    }
}